export default __webpack_public_path__ + "static/media/Boots of the Ichorous.5f5e34f7.jpg";